export default "__VITE_ASSET__RqZbLZOb__"